// Eventos y reservas.
//
// Vivia en `lib/api.js` junto con otros veintidos apartados (R4.5). Quien lo importa
// no se entero: `@/lib/api` sigue exportando exactamente lo mismo.
import { API, api } from "./client";

// ---- Events & bookings ----

export const getUpcomingEvents = async () => {
  const { data } = await api.get("/events");
  return data;
};

export const createBooking = async (eventId) => {
  const { data } = await api.post("/bookings", { event_id: eventId });
  return data;
};

export const getMyBookings = async () => {
  const { data } = await api.get("/bookings/mine");
  return data;
};

export const cancelBookingByToken = async (token) => {
  const { data } = await api.get(`/bookings/cancel/${token}`);
  return data;
};

export const getEventIcsUrl = (eventId) => `${API}/events/${eventId}/ics`;

// ---- El sábado en directo (admin) ----
// Las dos únicas puertas por las que puede existir una sesión: mirar si está convocada, y
// convocarla. Antes se creaba sola al listar los eventos y el Ágora anunciaba clase cada
// semana la diera alguien o no.

export const miraElSabado = async () => {
  const { data } = await api.get("/events/sabado");
  return data;
};

export const convocaElSabado = async (convocatoria) => {
  const { data } = await api.post("/events/sabado", convocatoria);
  return data;
};

// Los directos que ya se hicieron (N12): de momento, solo en el panel del admin.
export const getArchivoDelSabado = async () => (await api.get("/events/sabado/archivo")).data.sesiones;

export const anulaElSabado = async () => {
  const { data } = await api.delete("/events/sabado");
  return data;
};
